import AccessControlList from "./AccessControlList";
import BaseModel from "./BaseModels/BaseModel";

export default class Portalias extends BaseModel {
    name?: string
    acls?: AccessControlList[]
    in_use?: boolean
}